<div>
  <app-systems-in-country-filters (search)="searchData($event)">
  </app-systems-in-country-filters>
  <mat-divider></mat-divider>
  <app-systems-in-country-map-chart *ngIf="data"
                                    [title]="text"
                                    [subtitle]="subtitle"
                                    [data]="data">
  </app-systems-in-country-map-chart>
</div>
